import { Component, Input } from '@angular/core';
import { ViewChild } from '@angular/core';
import { ApexNonAxisChartSeries, ApexPlotOptions, ApexChart, ApexLegend, ChartComponent } from "ng-apexcharts";
import { CustomerDetailsModel } from '../customer-details.model';
export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  labels: string[];
  colors: string[];
  legend: ApexLegend;
  plotOptions: ApexPlotOptions;
};
@Component({
  selector: 'app-current-plan',
  templateUrl: './current-plan.component.html',
  styleUrls: ['./current-plan.component.scss']
})
export class CurrentPlanComponent {
  @Input() currentPlan = new CustomerDetailsModel();
  @ViewChild("chart") chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  ngOnInit() {
    this.chartOptions = {
      series: [50],
      chart: {
        height: 250,
        width: 230,
        type: 'radialBar',
      },
      plotOptions: {
        radialBar: {
          hollow: {
            size: '65%',
          },
          track: {
            background: '#fff',
          },
        },
      },
      labels: ['Days',],
      colors: ["#0DCF21"],
    };
  }
}
